module.exports = __webpack_public_path__ + "img/TO.baad858f.svg";